import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import GeneralDel from '../components/forms/GeneralDel'


const General = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='General Delegate Entry' text='Please complete the registration form' />
            <GeneralDel />
            <Banner />
            <Footer />
        </div>
    )
}

export default General
